import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const Lodging: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <g clipPath="url(#clip0_507_617)">
                <IconPath
                    d="M0.75 8.25L12 0.75L23.25 8.25M2.25 18.75H21.75M2.25 18.75V14.25H5.25C6.04565 14.25 6.80871 14.5661 7.37132 15.1287C7.93393 15.6913 8.25 16.4544 8.25 17.25V18.75H2.25ZM21.75 18.75V23.25H2.25V12.75M21.75 18.75H9L10.006 16.738C10.3797 15.9904 10.9542 15.3617 11.6651 14.9222C12.376 14.4828 13.1952 14.25 14.031 14.25H18.75C19.5456 14.25 20.3087 14.5661 20.8713 15.1287C21.4339 15.6913 21.75 16.4544 21.75 17.25V18.75Z"
                    {...pathProps}
                />
            </g>
            <defs>
                <clipPath id="clip0_507_617">
                    <rect width="24" height="24" fill="transparent" />
                </clipPath>
            </defs>
        </IconSVG>
    );
};
